import type { SurveyQuestionDTO } from '@/shared/api/types/survey-types'

/** Backend soft-delete; `is_deleted` is normalized to camelCase by the HTTP client. */
export function isSurveyQuestionDeleted(q: SurveyQuestionDTO): boolean {
  return q.isDeleted === true
}

export function filterActiveSurveyQuestions(questions: SurveyQuestionDTO[]): SurveyQuestionDTO[] {
  return questions.filter((q) => !isSurveyQuestionDeleted(q))
}
